<!--Outermost container for the Document Listing page. Has a required Jumbotron with title and search.-->

<template>
  <main class="pad">
    <div v-if="!loading">
      <!--Parallax and jumbotron with title-->

      <PageHeader
        v-if="documentListing.meta.parent.meta.type == 'departments.DepartmentLandingPage'"
        :title="documentListing.title"
        :logo_url="documentListing.logo ? documentListing.logo.meta.download_url : documentListing.get_department_logo_url"
        :image_url="documentListing.image ? documentListing.image.meta.download_url : documentListing.get_department_image_url"
        :subtitle="documentListing.subtitle ? documentListing.subtitle : ''"
        :dept_link="'/departmentlandingpage/'+parentSlug"
      ></PageHeader>

      <PageHeader
        v-else
        :title="documentListing.title"
        :logo_url="documentListing.logo ? documentListing.logo.meta.download_url : documentListing.get_homepage_logo_url"
        :image_url="documentListing.image ? documentListing.image.meta.download_url : documentListing.get_homepage_image_url"
        :subtitle="documentListing.subtitle ? documentListing.subtitle : ''"
      ></PageHeader>

      <!--Search Field-->

      <mdb-container>
        <mdb-row>
          <mdb-col>
            <div class="input-group md-form form-sm form-1 pl-0">
              <div class="input-group-prepend">
                <span class="input-group-text lighten-2">
                  <mdbIcon icon="search" />
                </span>
              </div>
              <input
                class="form-control my-0 py-1"
                type="text"
                placeholder="Search"
                v-model="searchQuery"
                aria-label="Search"
              />
            </div>
          </mdb-col>
        </mdb-row>

        <!--Load document search results or normal document listing-->

        <mdb-row class="my-3">
          <mdb-col>
            <DepartmentDocumentTab
              v-if="!loading && searchQuery == ''"
              :descendant_of="documentListing.id"
              :type="page_type == 'docs.DocumentListingPage' ? 'docs.TabPage' : 'departments.DepartmentTabPage'"
            ></DepartmentDocumentTab>
            <DepartmentDocumentSearch
              v-if="!loading && searchQuery != ''"
              :descendant_of="documentListing.id"
              :searchQuery="safeReturnSearch"
              :type="page_type == 'docs.DocumentListingPage' ? 'docs.Document' : 'departments.DepartmentDocument'"
            ></DepartmentDocumentSearch>
            <!--Type needs to reflect the type of the child.-->
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </div>
  </main>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbIcon } from "mdbvue";
import shared from "@/shared";
import api from "@/api";
import DepartmentDocumentTab from "@/views/departments/documents/DocumentTab.vue";
import DepartmentDocumentSearch from "@/views/departments/documents/DocumentSearch.vue";
import PageHeader from "@/views/PageHeader.vue";
export default {
  name: "DepartmentDocumentListing",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    DepartmentDocumentTab,
    DepartmentDocumentSearch,
    PageHeader,
  },
  props: {
    slug: {
      type: [String],
    },
    type: {
      type: [String],
      default: "departments.DepartmentDocumentListingPage", //TODO does not appear to be doing anything...
    },
  },
  data() {
    return {
      loading: true,
      documentListing: false,
      searchQuery: "",
      parentSlug: "",
      loaded: false,
      page_type: "",
    };
  },
  computed: {
    axiosParams() {
      const params = new URLSearchParams();
      params.append("fields", "*");
      return params;
    },
    safeReturnSearch() {
      return this.searchQuery.trim();
    },
  },
  methods: {
    getData() {
      api
        .get("pages/" + this.slug, {
          params: this.axiosParams,
        })
        .then((response) => {
          this.documentListing = response.data;
          shared.getDepartmentSkinFromPage(response.data);
          this.parentSlug = shared.extractParentSlug(
            this.documentListing.meta.parent.meta.html_url
          );
          if (!this.loaded) {
            this.loaded = true;
          }
          this.page_type = this.documentListing.meta.type;
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => (this.loading = false));
    },
    clearSearch() {
      this.searchQuery = "";
    },
  },
  watch: {
    slug: function () {
      // watch it
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
};
</script>